import React from 'react'

function Footer() {
  return (
    <div className='box-3'>
    <h1>Software Developer</h1>  
    </div>
  )
}

export default Footer
